<template>
  <div class="columns is-multiline">
    <div v-if="hasTitle" class="column is-12">
      <title-component>
        <slot></slot>
      </title-component>
    </div>
    <div class="table-holder">
      <hide-at v-if="content.length || dynamic_rows.length" :breakpoints="{small: 770}" breakpoint="small">
        <table class="table is-fullwidth is-hoverless">
          <thead>
            <tr>
              <th v-for="(heading, index) in headings"
                  :key="index"
                  :width="getColWidthForIndex(index)"
                  :class="getColClassesForIndex(index)">
                <translate>{{ heading }}</translate>
              </th>
            </tr>
          </thead>
          <tbody>
            <table-row-component
              v-for="(item, index) in content"
              :item="item"
              :index="index"
              :key="item.id"
              :bus="bus"
              :item_keys="item_keys"
              :display_spec="display_spec">
            </table-row-component>
            <table-row-dynamic-component
              v-for="(item, index) in dynamic_rows"
              :cells="item.cells"
              :index="index + content.length"
              :key="`dynamic-${index}`"
              :bus="bus">
            </table-row-dynamic-component>
          </tbody>
        </table>
      </hide-at>
      <show-at v-if="content.length || dynamic_rows.length" :breakpoints="{small: 769}" breakpoint="small" class="table-holder">
        <table class="table is-fullwidth is-hoverless">
          <tbody>
            <table-row-compact-component
              v-for="item in content"
              :item="item"
              :key="item.id"
              :bus="bus"
              :item_keys="item_keys"
              :display_spec="display_spec"
              :headings="headings">
            </table-row-compact-component>
            <table-row-dynamic-compact-component
              v-for="(item, index) in dynamic_rows"
              :cells="item.cells"
              :index="index + content.length"
              :key="`dynamic-${index}`"
              :bus="bus">
            </table-row-dynamic-compact-component>
          </tbody>
        </table>
      </show-at>
      <!-- Message that shows when the table is empty -->
      <message-component v-else :level="'info'">
        <translate> {{ empty_message || default_message }} </translate>
      </message-component>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { hideAt, showAt } from 'vue-breakpoints'
  import TitleComponent from '@/components/layout/TitleComponent'
  import TableRowComponent from '@/components/layout/table/TableRowComponent'
  import TableRowCompactComponent from '@/components/layout/table/TableRowCompactComponent'
  import TableRowDynamicComponent from '@/components/layout/table/TableRowDynamicComponent'
  import TableRowDynamicCompactComponent from '@/components/layout/table/TableRowDynamicCompactComponent'
  import MessageComponent from '@/components/layout/utility/MessageComponent'

  export default {
    name: 'table-component',
    data () {
      return {
        bus: new Vue(),
        dynamic_rows: [],
        default_message: 'The table is empty.'
      }
    },
    props: {
      headings: {
        type: Array,
        required: true
      },
      item_keys: {
        type: Array,
        required: true
      },
      content: {
        type: Array
      },
      display_spec: {
        type: Array
      },
      empty_message: {
        type: String,
        default: ''
      }
    },
    components: {
      TableRowComponent,
      TableRowCompactComponent,
      TableRowDynamicComponent,
      TableRowDynamicCompactComponent,
      TitleComponent,
      hideAt,
      showAt,
      MessageComponent
    },
    computed: {
      hasTitle () {
        return !!this.$slots.default
      }
    },
    methods: {
      getItemForKey (key) {
        return this.display_spec.find(i => i.item_key === key)
      },
      getColWidthForIndex (index) {
        return this.getColWidthForKey(this.item_keys[index])
      },
      getColWidthForKey (key) {
        return this.getItemForKey(key).width
      },
      getColClassesForIndex (index) {
        return this.getColClassesForKey(this.item_keys[index])
      },
      getColClassesForKey (key) {
        return this.getItemForKey(key).classes
      }
    }
  }
</script>
